import 'firebase/auth';
import 'firebase/firestore';

import app from 'firebase/app';

import { IUserModel } from '../stores/models/UserModel';
import { IPlaybackDocument, IQueueDocument } from '../stores/PlaybackStore';
import { AuthProviders } from '../types/shared';
import config from '../utils/config';

export enum PlaybackStatus {
    PLAYING = 'PLAYING',
    PAUSED = 'PAUSED',
}
class Firebase {
    constructor() {
        app.initializeApp(config.FIREBASE_CONFIG);
    }
    async signOut() {
        return await app.auth().signOut();
    }
    async signIn(fbToken: string) {
        return app.auth().signInWithCustomToken(fbToken);
    }

    async signInGuest(authProvider: AuthProviders) {
        let provider = new app.auth.GoogleAuthProvider();
        if (authProvider === AuthProviders.FACEBOOK) {
            provider = new app.auth.FacebookAuthProvider();
        }

        return await app.auth().signInWithPopup(provider);
    }

    async validatePartyLink(uid: string) {
        return await app
            .firestore()
            .collection(uid)
            .doc('playback')
            .get();
    }

    async storePlayback(uuid: string, data: IPlaybackDocument) {
        return await app
            .firestore()
            .collection(uuid)
            .doc('playback')
            .set(data);
    }

    async loadPlayback(uuid: string) {
        return await app
            .firestore()
            .collection(uuid)
            .doc('playback')
            .get();
    }

    async storeUserGuest(uuid: string, user: IUserModel) {
        const peopleDoc = await app
            .firestore()
            .collection(uuid)
            .doc('people')
            .get();

        if (!peopleDoc.data()) {
            return;
        }

        const people = peopleDoc.data() as IPeopleDocument;
        const userExists = people.guests.find(guest => guest.id === user.id);
        if (!userExists) {
            return await app
                .firestore()
                .collection(uuid)
                .doc('people')
                .update({ guests: [...people.guests, user] });
        }
        return;
    }

    async loadUsers(uuid: string) {
        return await app
            .firestore()
            .collection(uuid)
            .doc('people')
            .get();
    }

    async storeQueue(uuid: string, data: IQueueDocument) {
        return await app
            .firestore()
            .collection(uuid)
            .doc('queue')
            .set(data);
    }

    async loadQueueDoc(uuid: string) {
        return await app
            .firestore()
            .collection(uuid)
            .doc('queue');
    }

    async loadQueue(uuid: string) {
        return await app
            .firestore()
            .collection(uuid)
            .doc('queue')
            .get();
    }
}

export interface IPeopleDocument {
    host: IUserModel;
    guests: IUserModel[];
}

const firebaseService = new Firebase();
export default firebaseService;
